import { getTenantPreLoginConfig } from '../../tenant/teanantPreLoginConfig';

const createElement = (tagName, elementConfig) => {
  let element = document.createElement(tagName);
  Object.entries(elementConfig).forEach(([configName, configValue]) => {
    element.setAttribute(configName, configValue);
  });
  return element;
};

export const HeaderIcons = () => {
  const iconLinksConfig = getTenantPreLoginConfig().icon_links || [];
  return iconLinksConfig.map((iconConfig) => createElement('link', iconConfig));
};

export const ManifestFile = () => {
  const manifestConfig = getTenantPreLoginConfig().manifest || [];
  return createElement('link', manifestConfig);
};

export const Scripts = () => {
  const scriptsConfig = getTenantPreLoginConfig().scripts || [];
  return scriptsConfig.map((scriptConfig) =>
    createElement('script', scriptConfig)
  );
};

export const MetaTags = () => {
  const metaTagsConfig = getTenantPreLoginConfig().meta_tags || [];
  return metaTagsConfig.map((metaTagConfig) =>
    createElement('meta', metaTagConfig)
  );
};

export const addHeaderTags = () => {
  const tagElements = [
    ...HeaderIcons(),
    ManifestFile(),
    ...Scripts(),
    ...MetaTags(),
  ];
  tagElements.forEach((tagElement) => {
    document.head.appendChild(tagElement);
  });
};

export const addTitle = () => {
  document.title = getTenantPreLoginConfig().company_name;
};
